import { User } from '../models/user';
import { Action } from '@ngrx/store';
import { UserFilters } from '@users/models/user-filters';

export const LOAD = '[Users] Load';
export const LOAD_COMPLETE = '[Users] Load Complete';
export const LOAD_ERROR = '[Users] Load Error';

export const CREATE = '[Users] Create';
export const CREATE_COMPLETE = '[Users] Create Complete';
export const CREATE_ERROR = '[Users] Create Error';

export const INVITE = '[Users] Invite';
export const INVITE_SENT = '[Users] Invite Sent';
export const INVITE_ERROR = '[Users] Invite Error';

export const UPDATE = '[Users] Update';
export const UPDATE_COMPLETE = '[Users] Update Complete';
export const UPDATE_ERROR = '[Users] Update Error';

export const DISABLE = '[Users] Disable';
export const DISABLE_COMPLETE = '[Users] Disable Complete';
export const DISABLE_ERROR = '[Users] Disable Error';

export const SET_USERS_FILTER = '[Users] Set Users Filter';

export class Load implements Action {
  readonly type = LOAD;
  constructor( ) { }
}
export class LoadComplete implements Action {
  readonly type = LOAD_COMPLETE;
  constructor(public payload: User[]) { }
}
export class LoadError implements Action {
  readonly type = LOAD_ERROR;
  constructor(public payload : any ) { }
}

export class Create implements Action {
  readonly type = CREATE;
  constructor(public payload: User) { }
}
export class CreateComplete implements Action {
  readonly type = CREATE_COMPLETE;
  constructor() { }
}
export class CreateError implements Action {
  readonly type = CREATE_ERROR;
  constructor(public payload: any) { }
}

export class Update implements Action {
  readonly type = UPDATE;
  constructor(public payload: User) { }
}
export class UpdateComplete implements Action {
  readonly type = UPDATE_COMPLETE;
  constructor() { }
}
export class UpdateError implements Action {
  readonly type = UPDATE_ERROR;
  constructor(public payload: any) { }
}
export class Disable implements Action {
  readonly type = DISABLE;
  constructor(public payload: User) { }
}
export class DisableComplete implements Action {
  readonly type = DISABLE_COMPLETE;
  constructor() { }
}
export class DisableError implements Action {
  readonly type = DISABLE_ERROR;
  constructor(public payload: any) { }
}

export class Invite implements Action {
  readonly type = INVITE;
  constructor(public payload: User) { }
}

export class InviteSent implements Action {
  readonly type = INVITE_SENT;
  constructor(public payload: any) {}
}

export class InviteError implements Action {
  readonly type = INVITE_ERROR;
  constructor(public payload: any) { }
}

export class SetUsersFilter implements Action {
  readonly type = SET_USERS_FILTER;
  constructor(public payload: UserFilters) { }
}

export type Actions =
  | Load
  | LoadComplete
  | LoadError
  | Create
  | CreateComplete
  | CreateError
  | Update
  | UpdateComplete
  | UpdateError
  | Invite
  | InviteSent
  | InviteError
  | Disable
  | DisableComplete
  | DisableError
  | SetUsersFilter
;
